import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformanceSelectedRounds,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';
import { parse } from 'date-fns';

export default function useSelectedRounds() {
  const selectedRoundsStrings = useSelector(
    selectMeteorologyFieldsModelPerformanceSelectedRounds,
  );

  const selectedRounds = useMemo(() => {
    if (
      !selectedRoundsStrings
      || !Array.isArray(selectedRoundsStrings)
      || selectedRoundsStrings.length === 0
    ) {
      return [];
    }

    return selectedRoundsStrings.map((roundStr) => parse(roundStr, 'yyyy-MM-dd', new Date()));
  }, [selectedRoundsStrings]);

  const setSelectedRounds = useCallback((dates: Date[]) => {
    const roundStrings = dates.map(
      (date) => date.toISOString().split('T')[0],
    );

    store.dispatch(
      setFilter({
        selectedRounds:
          roundStrings.length > 0 ? roundStrings : undefined,
      }),
    );
  }, []);

  return {
    selectedRounds,
    setSelectedRounds,
  };
}
